import { CSS } from '@grupoboticario/flora-react'

export const headerCss: CSS = {
  padding: '$4',
  backgroundColor: 'white'
}

export const closeButtonCss: CSS = {
  padding: 0
}

export const bodyWrapperCss: CSS = {
  backgroundColor: 'white'
}
